module.exports = __webpack_public_path__ + "static/media/surtidor-gris.ff9f7c5d.svg";